import Select from './select';
import mapProps from '../scripts/utils/map-props';

export default mapProps(
  [
    {
      name: 'value',
      dependencies: ['options'],
    },
  ],
  {
    model: {
      prop: 'value',
      event: ['change', 'input'],
    },
  }
)(Select);
